import { Box, Container } from "@mui/material";
import { type ReactNode } from "react";

interface AIChatTemplateProps {
  children: ReactNode;
}

export const AIChatTemplate = ({ children }: AIChatTemplateProps) => {
  return (
    <Box
      sx={{
        // Viewport height minus navbar (64px) and footer (48px)
        display: "flex",

        flexDirection: "column",
        minHeight: "calc(100vh - 64px - 48px)",
        p: { sm: 2, xs: 1.5 },
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          backgroundColor: "background.paper",
          borderRadius: 1,
          display: "flex",
          flex: 1,
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        {children}
      </Container>
    </Box>
  );
};
